var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.data.content.headers,"items":_vm.data.content.desserts}})
}
var staticRenderFns = []

export { render, staticRenderFns }